import { render, staticRenderFns } from "./openstreetmap.vue?vue&type=template&id=1685744e&"
import script from "./openstreetmap.vue?vue&type=script&lang=js&"
export * from "./openstreetmap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1685744e')) {
      api.createRecord('1685744e', component.options)
    } else {
      api.reload('1685744e', component.options)
    }
    module.hot.accept("./openstreetmap.vue?vue&type=template&id=1685744e&", function () {
      api.rerender('1685744e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Z0c27ByoltyX/JS/comp/openstreetmap.vue"
export default component.exports